<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a
        style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"

        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在"
               style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a style="color: #f56c6c">删除</a>
          </a-popconfirm>
        </span>

      </a-table>
    </div>

    <fileConfigRole-modal ref="modalForm" @ok="modalFormOk"></fileConfigRole-modal>
  </a-card>
</template>

<script>

import {JeecgListMixin} from '@/mixins/JeecgListMixin'
import FileConfigRoleModal from './modules/FileConfigRoleModal'


export default {
  name: "FileConfigRoleList",
  mixins: [JeecgListMixin],
  components: {
    FileConfigRoleModal
  },
  data() {
    return {
      disableMixinCreated: true,
      description: '附件配置角色表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '配置',
          align: "center",
          dataIndex: 'config_dictText'
        },
        {
          title: '角色',
          align: "center",
          dataIndex: 'role'
        },
        {
          title: '角色名',
          align: "center",
          dataIndex: 'role_dictText'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ],
      url: {
        list: "/file.base/fileConfigRole/list",
        delete: "/file.base/fileConfigRole/delete",
        deleteBatch: "/file.base/fileConfigRole/deleteBatch",
        exportXlsUrl: "/file.base/fileConfigRole/exportXls",
        importExcelUrl: "file.base/fileConfigRole/importExcel",
      },
      dictOptions: {},
      fileConfig: {}
    }
  },
  created() {
    console.log('created===================>')
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  methods: {
    init(config) {
      console.log(config)
      this.fileConfig = config
      this.queryParam.config = config.id
      console.log('init===================>')
      this.loadData()
    },
    handleAdd: function () {
      this.$refs.modalForm.add(this.fileConfig)
      this.$refs.modalForm.title = '新增'
      this.$refs.modalForm.disableSubmit = false

    },
    initDictConfig() {
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>